import { render } from "./Legend.vue?vue&type=template&id=68fdbee9&scoped=true&ts=true"
import script from "./Legend.vue?vue&type=script&lang=ts"
export * from "./Legend.vue?vue&type=script&lang=ts"

import "./Legend.vue?vue&type=style&index=0&id=68fdbee9&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68fdbee9"]])

export default __exports__